/**
 * Extract filename from a file path
 * Handles both forward slashes and backslashes
 */
export function getFileNameFromPath(filePath: string): string {
  if (!filePath) return '';
  const normalized = filePath.replace(/\\/g, '/');
  const parts = normalized.split('/');
  const last = parts[parts.length - 1];
  return last || filePath;
}

/**
 * Get the display name for a database identifier
 * For SQLite, shows only the filename but preserves the full path in the title attribute
 * For other databases, returns the identifier unchanged
 *
 * @param database - The database identifier (database name or file path for SQLite)
 * @param engine - The database engine type
 * @returns Object with displayName and fullPath (for tooltip)
 */
export function getDatabaseDisplayName(
  database: string | undefined,
  engine: string
): { displayName: string; fullPath: string } {
  if (!database) {
    return { displayName: '', fullPath: '' };
  }

  // SQLite stores the full file path as the database identifier
  if (engine === 'sqlite') {
    // Check if this looks like a file path (contains slashes or backslashes)
    const looksLikeFilePath = /[/\\]/.test(database);
    if (looksLikeFilePath) {
      return {
        displayName: getFileNameFromPath(database),
        fullPath: database,
      };
    }
  }

  // For other databases or non-path SQLite identifiers, return as-is
  return {
    displayName: database,
    fullPath: database,
  };
}
